import { kmsClient } from 'api';
import { CCA_GENERATION_JOB_QUERY } from './ccaGenerationJob.query';
import {
  CcaGenerationJobQuery,
  CcaGenerationJobQuery_ccaGenerationJob as CcaGenerationJob,
  CcaGenerationJobQueryVariables
} from './__generated__/CcaGenerationJobQuery';

const POLL_INTERVAL_MS = 1000;

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

// Polls `ccaGenerationJob(id:)` every second until the job is terminal
// (`done` or `failed`). Returns the final job snapshot. Throws if the server
// returns a null job or never reaches a terminal state inside `maxAttempts`.
export const pollCcaGenerationJob = async (
  jobId: string,
  options: { intervalMs?: number; maxAttempts?: number } = {}
): Promise<CcaGenerationJob> => {
  const intervalMs = options.intervalMs ?? POLL_INTERVAL_MS;
  const maxAttempts = options.maxAttempts ?? 600; // 10 minutes at 1s

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const result = await kmsClient.query<CcaGenerationJobQuery, CcaGenerationJobQueryVariables>({
      query: CCA_GENERATION_JOB_QUERY,
      variables: { id: jobId },
      fetchPolicy: 'no-cache'
    });
    const job = result.data?.ccaGenerationJob;
    if (!job) throw new Error(`CCA generation job ${jobId} not found`);
    if (job.status === 'done' || job.status === 'failed') return job;
    await sleep(intervalMs);
  }

  throw new Error(`CCA generation job ${jobId} did not finish in time`);
};
